import React from 'react'
import { Container } from '@quotatisgroup/uikit-public.ui.container'
import { Row } from '@quotatisgroup/uikit-public.ui.row'
import { Col } from '@quotatisgroup/uikit-public.ui.col'
import { Button } from '@quotatisgroup/uikit-public.ui.button'
import { Title } from '@quotatisgroup/uikit-public.ui.title'
import { Image } from '@quotatisgroup/uikit-public.ui.image'
import { Text } from '@quotatisgroup/uikit-public.ui.text'
import UniverseLink from 'components/UniverseLink/UniverseLinkContainer'
import cloudinary from 'utils/cloudinary'
import injectTranslate from 'i18n/hoc/injectTranslate'
import PropTypes from 'prop-types'
import { StyledCol } from './ProHomePageContentStyle'

const ProInfoBlock = ({ translate }) => (
  <Container>
    <Row hasVerticalAlign padding="horizontal-md" mdPadding="vertical-lg">
      <StyledCol sm="12" md="8" offset="2">
        <Title headingLevel="2" align="center">
          {translate('propage.block5.title')}
        </Title>
      </StyledCol>
      <Col sm="12" md="6">
        <Image
          src={cloudinary('/vitrine/image/7.png')}
          size="full"
          alt={translate('alt.pro.macbook')}
        />
      </Col>
      <Col sm="12" md="6">
        <Title headingLevel="3" margin="bottom-sm">
          {translate('propage.block5.sub1.title')}
        </Title>
        <Text color="grey" margin="top-sm">
          {translate('propage.block5.sub1.text')}
        </Text>
        <Title headingLevel="3" margin="bottom-sm">
          {translate('propage.block5.sub2.title')}
        </Title>
        <Text color="grey" margin="top-sm">
          {translate('propage.block5.sub2.text')}
        </Text>
        <Title headingLevel="3" margin="bottom-sm">
          {translate('propage.block5.sub3.title')}
        </Title>
        <Text color="grey" margin="top-sm">
          {translate('propage.block5.sub3.text')}
        </Text>
        <Title headingLevel="3" margin="bottom-sm">
          {translate('propage.block5.sub4.title')}
        </Title>
        <Text color="grey" margin="top-sm">
          {translate('propage.block5.sub4.text')}
        </Text>
      </Col>
    </Row>
    <Row padding="horizontal-md" mdPadding="bottom-lg">
      <Col sm="12" md="6" offset="3" align="center">
        <UniverseLink id="pro-block5-link" href="/inscription-artisan-poseur">
          <Button
            id="button-pro-block5"
            variant="primary"
            size="lg"
            margin="right-sm"
          >
            {translate('propage.block5.sub5.button')}
          </Button>
        </UniverseLink>
        <Title headingLevel="3">{translate('propage.block5.sub5.text')}</Title>
        <UniverseLink
          id="pro-register-link"
          href="/inscription-annuaire"
          isBold
          icon="arrow-right-blue"
          iconPosition="right"
          iconSize="sm"
        >
          {translate('propage.block5.sub5.link')}
        </UniverseLink>
        <Text color="grey" margin="top-md">
          {translate('propage.block5.sub6.text')}
        </Text>
      </Col>
    </Row>
  </Container>
)

ProInfoBlock.propTypes = {
  translate: PropTypes.func,
}

export default injectTranslate(ProInfoBlock)
